/* 
// jQuery: initPremiumHotelWidgets
// This set of functionality is used to handle loading the ARN Premium Hotel Benefit Widgets
*/

jQuery(function initPremiumHotelWidgets($) {
	$('.js-premium-hotel-benefits-preview').each(function(index, el) {

		TRIPAUTHORITY_URL = "api.travsrv.com";
		DEEPLINK_HOST     = "hotels.afvclub.com";

		// **************************************************************************************************************
		// PREMIUM PREVIEW - ARN WIDGET - FEATURED HOTEL PROPERTIES
		// This code was provided by ARN and modified to fit into the AFVC platform
		// **************************************************************************************************************

		(function () {

		    var cnt = 0;
		    var hoteldealspopulated = false;
		    var featuredPropertiesContainerContent = "featuredPropertiesContainerContent";
		  
		    function main() {
		        
		        cnt++;

		        function getUrlParameter(name, searchLocation) {
		            
		            if (searchLocation == undefined) {
		                searchLocation = window.location.search;
		            }

		            var match = new RegExp('[?&]' + name + '=([^&]*)').exec(searchLocation);
		            return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
		        }

		        //simple implementation of translate
		        if (typeof translate === "undefined") {
		           
		            translate = function translate(text) {
		                return text;
		            }
		        }

		        //URL Parms
		        //      attachclassname
		        //      maxresultcount
		        //      currency
		        //      propertyids   ex.. 12345,133435,1324545
		        //      options    ex. minproprating=4

		        function callHotelDeals() {

		            var attachClassName = getUrlParameter("attachclassname", jQuery("#hoteldeals_script").attr("src"));
		            if (!attachClassName || attachClassName.length == 0) {
		                attachClassName = "featuredContainer";
		            }
		            var hotelDealsCount = getUrlParameter("maxresultcount", jQuery("#hoteldeals_script").attr("src"));
		            if (!hotelDealsCount || hotelDealsCount.length == 0) {
		                hotelDealsCount = "3";
		            }
		            var currency = getUrlParameter("currency", jQuery("#hoteldeals_script").attr("src"));
		            if (!currency || currency.length == 0) {
		                currency = "USD";
		            }

		            var propertyids = getUrlParameter("propertyids", jQuery("#hoteldeals_script").attr("src"));
		            if (!propertyids || propertyids.length == 0) {
		                propertyids = "";
		            }

		            var options = getUrlParameter("options", jQuery("#hoteldeals_script").attr("src"));
		            if (!options || options.length == 0) {
		                options = "";
		            }

		            var isqaparam = getUrlParameter("isqa", jQuery("#hoteldeals_script").attr("src"));
		            if (isqaparam && isqaparam.toLowerCase() == "true") {
		                isqa = true;
		            } else {
		                isqa = false;
		            }

		            if (jQuery("." + attachClassName).length > 0 && jQuery("."+featuredPropertiesContainerContent).length == 0) {
		                
		                var hotelDealsContainer = jQuery("." + attachClassName).first();
		                hotelDealsContainer.append(jQuery("<div class=\""+featuredPropertiesContainerContent+"\">"));

		                var hotelDealsService = "https://"+TRIPAUTHORITY_URL;
		                if (isqa) hotelDealsService = "https://tripqa.reservetravel.com";
		                hotelDealsService += "/Content.aspx?type=findfeaturedhoteldeals&maxresultcount="+hotelDealsCount+"&currency="+currency+"&propertyids="+propertyids+"&"+ options + "&locationid=9641";
		                var searchType = jQuery("meta[name='SearchType']").attr("content");
		                if (searchType == "Destination") hotelDealsService += "&iscondo=true";

		                jQuery.get(hotelDealsService)
		                        .success(function (data) {
		                            processHotelDeals(data);
		                        })
		                        .error(function (jqXHR, textStatus, errorThrown) {
		                            var errorTxt = textStatus;
		                            if (errorThrown && errorThrown != undefined) {
		                                errorTxt = errorThrown.name + " " + errorThrown.message;
		                                errorTxt += errorThrown.stacktrace != undefined ? " " + errorThrown.stacktrace : "" + errorThrown.stack != undefined ? " " + errorThrown.stack : "";
		                            }
		                            console.log("Deals Service Failure: " + errorTxt);
		                        });
		            }
		        }

		        //URL Parms
		        //      deeplinkparams         ex.. "propertyclasses=4%20Stars%2C5%20Stars";

		        function processHotelDeals(dealData) {
		            
		            var deeplinkparams = getUrlParameter("deeplinkparams", jQuery("#hoteldeals_script").attr("src"));
		            if (!deeplinkparams || deeplinkparams.length == 0) {
		                deeplinkparams = "";
		            }

		            var container = jQuery("." + featuredPropertiesContainerContent).first();
		            var featuredPropertiesDiv = jQuery("<div class=\"text\">");

		            for (var i = 0; i < (dealData.length || 3); i++) {
		                dealData[i].LocationId;

		                var featuredProperty = jQuery("<a class=\"featuredProperty\">");
		                featuredPropertiesDiv.append(featuredProperty);

		                var currency = dealData[i].ReferencePriceCurrency;
		                if (currency == undefined) currency = "USD";
		                var currencySymbol = (currency == "USD") ? "$" : (currency == "GBP") ? "Â£" : "";
		                var currencySymbolPost = (currencySymbol == "") ? currency : "";

		                // featuredProperty.append("<img border=\"0\" src=\"" + dealData[i].PropertyImageUrl + "\">" +

		                featuredProperty.append("<div class=\"feature-image\" style=\"background-image: url(" + dealData[i].PropertyImageUrl + ");\"></div>" +
		                        "<h2>" + dealData[i].PropertyName + "</h2>" +
		                        "<h3>" + dealData[i].PropertyAddress + "</h3>" +
		                        "<span class=\"maxDiscount\">" + translate("Up to") + " " + dealData[i].MaxDiscountPercent.toFixed(0) + "% " + translate("off") + "</span>" +
		                        "<span class=\"featuredPrice\"><p>" + translate("from") + ": " + currencySymbol + dealData[i].ReferencePrice.toFixed(2) + " "+ currencySymbolPost + "</p> </span>" +
		                        "<div class=\"tripAdvisorContainer\"><img border=\"0\" src=\"" + dealData[i].RatingImageUrl + "\"><div class=\"tripAdvisor\">" + dealData[i].TripAdvisorRating.toFixed(1) + "</div></div>");
		            }
		            container.append(featuredPropertiesDiv);
		        }


		        function insertArnScript(id,url,style){var js,ijs=document.getElementsByTagName("script")[0];if(document.getElementById(id)){return}if(style){js=document.createElement('link');js.rel="stylesheet";js.type="text/css";js.href=url;}else{js=document.createElement("script");js.src=url;}js.id=id;ijs.parentNode.insertBefore(js,ijs)}
		        if (window.console == undefined || window.console.log == undefined) {
		            if (window.console == undefined) window.console = {};
		            window.console.log = function(log) {};
		        }

		        //do stuff, but make sure jQuery is loaded
		        if (window.jQuery == undefined) {
		            //add jquery on first pass
		            if (cnt == 1) {
		                cnt++;
		                insertArnScript("jquery_script", "https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.3/jquery.min.js");
		            }
		            //circle back around to main in 100ms if the counter is not exhausted
		            setTimeout(function () {
		                if (cnt < 20) main();
		            }, 100);
		        } else {
		            //do main function
		            if (!hoteldealspopulated) {
		                hoteldealspopulated = true;
		                callHotelDeals();
		            }
		        }
		    }
		    main();
		})();

		// **************************************************************************************************************
		// PREMIUM PREVIEW - ARN WIDGET - FEATURED DESTINATIONS
		// This code was provided by ARN and modified to fit into the AFVC platform
		// **************************************************************************************************************

		(function () {

		    var cnt = 0;
		    var locationdealspopulated = false;
		    var featuredDestinationsContentContainer = "featuredDestinationsContainerContent";
		   
		    function main() {

		        cnt++;

		        function getUrlParameter(name, searchLocation) {

		            if (searchLocation == undefined) {
		                searchLocation = window.location.search;
		            }

		            var match = new RegExp('[?&]' + name + '=([^&]*)').exec(searchLocation);
		            return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
		        }

		        //simple implementation of translate
		        if (typeof translate === "undefined") {
		            
		            translate = function translate(text) {
		                return text;
		            }
		        }

		        //URL Parms
		        //      attachclassname
		        //      maxresultcount
		        //      currency

		        function callLocationDeals() {
		           
		            var attachClassName = getUrlParameter("attachclassname", jQuery("#locationdeals_script").attr("src"));
		            if (!attachClassName || attachClassName.length == 0) {
		                attachClassName = "featuredDestinationsContainer";
		            }
		            var maxresultcount = getUrlParameter("maxresultcount", jQuery("#locationdeals_script").attr("src"));
		            if (!maxresultcount || maxresultcount.length == 0) {
		                maxresultcount = "2";
		            }
		            var options = getUrlParameter("options", jQuery("#locationdeals_script").attr("src"));
		            if (!options || options.length == 0) {
		                options = "";
		            }

		            var isqaparam = getUrlParameter("isqa", jQuery("#locationdeals_script").attr("src"));
		            if (isqaparam && isqaparam.toLowerCase() == "true") {
		                isqa = true;
		            } else {
		                isqa = false;
		            }

		            if (jQuery("." + attachClassName).length > 0 && jQuery("."+featuredDestinationsContentContainer).length == 0) {
		                
		                var destinationsContainer = jQuery("." + attachClassName).first();
		                destinationsContainer.append(jQuery("<div class=\""+featuredDestinationsContentContainer+"\">"));

		                var currency = jQuery("meta[name='currency']").attr("content");
		                if (currency == undefined) currency = "USD";
		                var locationDealsService = "https://"+TRIPAUTHORITY_URL;
		                if (isqa) locationDealsService = "https://tripqa.reservetravel.com";
		                locationDealsService += "/Content.aspx?type=findfeaturedlocationdeals&maxresultcount="+maxresultcount+"&currency="+currency+"&"+ options + "&locationids=9641,9044";
		                var searchType = jQuery("meta[name='SearchType']").attr("content");
		                if (searchType == "Destination") locationDealsService += "&iscondo=true";

		                jQuery.get(locationDealsService)
		                    .success(function (data) {
		                        processLocationDeals(data);
		                    })
		                    .error(function (jqXHR, textStatus, errorThrown) {
		                        var errorTxt = textStatus;
		                        if (errorThrown && errorThrown != undefined) {
		                            errorTxt = errorThrown.name + " " + errorThrown.message;
		                            errorTxt += errorThrown.stacktrace != undefined ? " " + errorThrown.stacktrace : "" + errorThrown.stack != undefined ? " " + errorThrown.stack : "";
		                        }
		                        console.log("Location Deals Service Failure: " + errorTxt);
		                    });
		            }
		        }

		        function processLocationDeals(dealData) {
		            
		            var container       = jQuery("." + featuredDestinationsContentContainer).first();
		            var deeplinkoptions = getUrlParameter("deeplinkoptions", jQuery("#locationdeals_script").attr("src"));
		            
		            if (!deeplinkoptions || deeplinkoptions.length == 0) {
		                deeplinkoptions = "";
		            }

		            for (var i = 0; i < (dealData.length || 2); i++) {
		                
		                var destinationBox       = jQuery("<div class=\"featuredDestination box" + (i + 1) + "\">");
		                var destinationThumb     = jQuery("<div class=\"destinationThumb\">");

		                // var destinationThumbLink = jQuery("<a href=\"//" + DEEPLINK_HOST + "/v6?type=hotellist&city=" + encodeURIComponent(dealData[i].LocationName) + "&"+ deeplinkoptions + "\"><img src='//media.travsrv.com/appSkins/64/v6/themes/global/skins/images/empty.gif'></a>");
		                var destinationThumbLink = jQuery("<img src='//media.travsrv.com/appSkins/64/v6/themes/global/skins/images/empty.gif'>");
		                
		                destinationThumb.append(destinationThumbLink);
		                destinationBox.append(destinationThumb);

		                var currency = dealData[i].AvgNightlyPriceCurrency;
		                if (currency == undefined) currency = "USD";
		                var currencySymbol = (currency == "USD") ? "$" : (currency == "GBP") ? "Â£" : "";
		                var currencySymbolPost = (currencySymbol == "") ? currency : "";
		                var destinationSavings = jQuery("<div class=\"destinationSavings\">");

		                // var destinationSavingsLink = jQuery("<a class=\"savingsLink\" href=\"//" + DEEPLINK_HOST + "/v6?type=hotellist&city=" + encodeURIComponent(dealData[i].LocationName) + "&"+ deeplinkoptions + "\"><span class=\averagePercenteOff\>" + translate("Average Savings") + ": " + dealData[i].AvgDiscountPercent + "% " + translate("Off") + "</span> " + translate("Savings in") + " " + dealData[i].LocationName + "<span>" + dealData[i].DealsFound + " " + translate("Deals Found") + "</span></a>");
		                // var destinationSavingsText = jQuery("<a class=\"destinationIncentiveLink\" href=\"//" + DEEPLINK_HOST + "/v6?type=hotellist&city=" + encodeURIComponent(dealData[i].LocationName) + "&"+ deeplinkoptions + "\"><span class=\"averageNightlyLabel\">" + translate("Average Nightly Rate") + ":</span> " + currencySymbol + dealData[i].AvgNightlyPrice.toFixed(2) + " " + currencySymbolPost + "</a>");

		                var destinationSavingsLink = jQuery("<a class=\"savingsLink\"><span class=\averagePercenteOff\>" + translate("Average Savings") + ": " + dealData[i].AvgDiscountPercent + "% " + translate("Off") + "</span> " + translate("Savings in") + " " + dealData[i].LocationName + "<span>" + dealData[i].DealsFound + " " + translate("Deals Found") + "</span></a>");
		                var destinationSavingsText = jQuery("<a class=\"destinationIncentiveLink\"><span class=\"averageNightlyLabel\">" + translate("Average Nightly Rate") + ":</span> " + currencySymbol + dealData[i].AvgNightlyPrice.toFixed(2) + " " + currencySymbolPost + "</a>");
		                
		                destinationSavings.append(destinationSavingsLink);
		                destinationSavings.append(destinationSavingsText);
		                destinationBox.append(destinationSavings);

		                destinationBox.css("background-image", "url(" + dealData[i].LocationImageUrl + ")");

		                container.append(destinationBox);
		            }
		        }


		        function insertArnScript(id,url,style){var js,ijs=document.getElementsByTagName("script")[0];if(document.getElementById(id)){return}if(style){js=document.createElement('link');js.rel="stylesheet";js.type="text/css";js.href=url;}else{js=document.createElement("script");js.src=url;}js.id=id;ijs.parentNode.insertBefore(js,ijs)}
		        if (window.console == undefined || window.console.log == undefined) {
		            if (window.console == undefined) window.console = {};
		            window.console.log = function(log) {};
		        }

		        //do stuff, but make sure jQuery is loaded
		        if (window.jQuery == undefined) {
		            //add jquery on first pass
		            if (cnt == 1) {
		                cnt++;
		                insertArnScript("jquery_script", "https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.3/jquery.min.js");
		            }
		            //circle back around to main in 100ms if the counter is not exhausted
		            setTimeout(function () {
		                if (cnt < 20) main();
		            }, 100);
		        } else {
		            //do main function
		            if (!locationdealspopulated) {
		                locationdealspopulated = true;
		                callLocationDeals();
		            }
		        }
		    }
		    main();
		})();
	});
});

